import { combineReducers } from "redux";
import caseStatus from "./countCaseStatus";
import severity from"./severity";
export default combineReducers({
  caseStatus,
  severity
});
